<template>
  <div class="main-content">
    <b-container class="pb-5">
      <b-row class="mt-5">
        <b-col lg="6" offset-lg="3">
          <h1>Recupera la tua password</h1>
          <p class="text-secondary">Inserisci il tuo nome utente e premi recupera.</p>
          <b-form v-on:submit.prevent="onSubmit">
            <b-form-group label="Username">
              <b-form-input
                type="text"
                v-model="login.username"
                label="Username"
                required
                placeholder="Inserisci username"
                v-validate="'required'"
                data-vv-name="username">
              </b-form-input>
            </b-form-group>

            <hr>
              <b-button size="lg" type="submit" variant="primary" class="mr-2">Recupera</b-button>
              <b-button size="lg" type="button" variant="outline-danger" :to="'login'">Torna al login</b-button>
          </b-form>
          <b-alert variant="danger" show v-if="error" class="mt-3">Attenzione! {{ error }}</b-alert>
        </b-col>
      </b-row>

    </b-container>
  </div>
</template>

<script>
  import VueRecaptcha from 'vue-recaptcha';

  export default {
    name: 'Recover',
    components: {VueRecaptcha},
    data() {
      return {
        login: {
          username: '',
          password: '',
        },
        e1: true,
        error: null,
      };
    },

    methods: {
      onSubmit() {
        console.log('onSubmit');
        //this.$refs.recaptcha.execute();
        this.onVerify();
      },

      async onVerify(recaptchaToken) {
        console.log('onCaptchaVerified', recaptchaToken);

        try {
          const res = await this.$apiclient.recoverPassword({username: this.login.username, recaptchaToken});
          await this.$swal('Recupero password', 'La password è stata resettata con successo: controlla la tua mail e/o cellulare.', 'success');
          this.$router.push('/login');
        } catch (err) {
          console.log('password recover error', err);
          this.$swal('Recupero password', 'Non è stato possibile recuperare la password. Assicurarsi di aver inserito uno username valido o che siano trascorsi almeno 10 minuti dall\'ultimo reset. ', 'error');
        }
      },

      onExpired: function () {
        console.log('Expired');
        this.$refs.recaptcha.reset();
      },
      resetRecaptcha() {
        this.$refs.recaptcha.reset(); // Direct call reset method
      },

    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Recover.vue